import LegalLayout, { Section, Bullets } from "../components/site/LegalLayout";

export default function Privacidad() {
  return (
    <LegalLayout testid="privacy-page" eyebrow="OMNIA · Legal"
      title="Aviso de Privacidad Integral"
      updated="Última actualización: 8 de julio de 2026">

      <Section title="1. Identidad y Domicilio del Responsable">
        <p>King of Kongo S. de R.L. de C.V. (en adelante, "la Empresa"), con domicilio en Av. Centenario 394, Local 1, Colonia Merced Gómez, Alcaldía Álvaro Obregón, C.P. 01600, Ciudad de México, es la entidad responsable del tratamiento de sus datos personales conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).</p>
      </Section>

      <Section title="2. Datos Personales Tratados">
        <p>La Empresa recaba y trata las siguientes categorías de datos, dependiendo de la naturaleza de su interacción:</p>
        <Bullets items={[
          <><span className="text-navy font-medium">Datos de identificación y contacto:</span> Nombre, denominación social, domicilio, teléfono, correo electrónico, RFC, CURP.</>,
          <><span className="text-navy font-medium">Datos financieros y patrimoniales:</span> Cuentas bancarias, estados de cuenta, información de tarjetas de crédito/débito para facturación y pagos.</>,
          <><span className="text-navy font-medium">Datos de navegación y dispositivos:</span> Dirección IP, tipo de navegador, cookies, geolocalización, identificadores de dispositivos y comportamiento dentro de nuestros sitios web.</>,
          <><span className="text-navy font-medium">Datos de terceros:</span> Información que el usuario nos suministra sobre terceros para la ejecución de servicios de consultoría y gestión estratégica.</>,
        ]} />
      </Section>

      <Section title="3. Finalidades del Tratamiento">
        <p className="text-navy font-medium">A. Finalidades Primarias:</p>
        <Bullets items={[
          "Gestión de la relación comercial, contractual y de servicios.",
          "Procesamiento de pagos, facturación y gestión administrativa.",
          "Cumplimiento de obligaciones fiscales, legales y regulatorias.",
          "Atención a requerimientos de autoridades competentes.",
          "Verificación de la veracidad de la información proporcionada.",
        ]} />
        <p className="text-navy font-medium pt-2">B. Finalidades Secundarias:</p>
        <Bullets items={[
          "Prospección comercial, envío de publicidad y promociones personalizadas.",
          "Análisis de datos para el desarrollo de nuevos servicios y mejora de la experiencia de usuario.",
          "Realización de encuestas de satisfacción y estudios de mercado.",
        ]} />
      </Section>

      <Section title="4. Transferencias de Datos Personales">
        <p>La Empresa podrá transferir sus datos personales sin requerir consentimiento en los casos previstos por el Art. 37 de la LFPDPPP. Asimismo, podrá transferir datos a:</p>
        <Bullets items={[
          <><span className="text-navy font-medium">Proveedores de servicios:</span> Terceros encargados de servicios tecnológicos, plataformas de pago, gestión de servidores en la nube y servicios de marketing, bajo estrictos contratos de confidencialidad.</>,
          <><span className="text-navy font-medium">Empresas del mismo grupo:</span> Para fines de administración, auditoría interna y consolidación de la operación.</>,
          <><span className="text-navy font-medium">Autoridades:</span> Cumplimiento de requerimientos judiciales o administrativos.</>,
        ]} />
      </Section>

      <Section title="5. Ejercicio de Derechos ARCO y Revocación">
        <p>Usted tiene derecho a acceder, rectificar, cancelar u oponerse (Derechos ARCO) al tratamiento de sus datos.</p>
        <Bullets items={[
          <><span className="text-navy font-medium">Procedimiento:</span> Envíe un correo a administracion@gout.global con el asunto "Ejercicio de Derechos ARCO".</>,
          <><span className="text-navy font-medium">Requisitos:</span> Debe incluir: (i) nombre completo, (ii) copia de identificación oficial, (iii) descripción clara de los derechos que desea ejercer y (iv) cualquier documento que facilite la localización de sus datos.</>,
          <><span className="text-navy font-medium">Plazos:</span> La Empresa responderá en un plazo máximo de 20 días hábiles, contados a partir de la recepción de su solicitud.</>,
        ]} />
      </Section>

      <Section title="6. Limitación del Uso o Divulgación">
        <p>Para limitar el uso o divulgación de sus datos (por ejemplo, dejar de recibir correos publicitarios), puede solicitar su inscripción en nuestro "Listado de Exclusión" enviando un mensaje a la dirección de contacto indicada.</p>
      </Section>

      <Section title="7. Uso de Tecnologías de Rastreo">
        <p>Nuestro Sitio utiliza cookies, web beacons y otras tecnologías que permiten recabar datos automáticamente. Estas tecnologías pueden ser deshabilitadas mediante la configuración de su navegador. El usuario reconoce que el bloqueo de cookies puede afectar la funcionalidad del Sitio.</p>
      </Section>

      <Section title="8. Seguridad de la Información">
        <p>La Empresa utiliza protocolos de seguridad física, técnica y administrativa (cifrado, firewalls, controles de acceso) con estándares internacionales para proteger su información contra daños, pérdida, alteración, destrucción o uso no autorizado.</p>
      </Section>

      <Section title="9. Modificaciones al Aviso">
        <p>Cualquier cambio a este Aviso de Privacidad será publicado en el sitio www.omniagroup.mx. El uso continuado de nuestros servicios después de la actualización constituye su aceptación expresa.</p>
      </Section>
    </LegalLayout>
  );
}
